import { InputAdornment, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { inputBaseClasses } from "@mui/material/InputBase";
import { selectClasses } from "@mui/material/Select";
import { FC } from "react";
import { SelectField } from "../..";
import { ESortDirection, ISortModel } from "../model/types";
import { FilterButton } from "./TableFilters/FilterButton";

interface TableSingleSort {
  sortModel: ISortModel;
}

const TableSingleSort: FC<TableSingleSort> = ({
  sortModel: { onSort, value, options },
}) => {
  const { sortBy, sortDirection } = value;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <Box>
        <SelectField
          value={sortBy}
          onChange={(e) =>
            onSort({
              sortBy: String(e.target.value),
              sortDirection: String(e.target.value) ? sortDirection : "",
            })
          }
          displayEmpty
          startAdornment={
            <Typography
              sx={{
                fontWeight: sortBy ? 700 : 400,
                color: "grey.800",
                whiteSpace: "nowrap",
              }}
            >
              Sort by&nbsp;
            </Typography>
          }
          endAdornment={
            sortBy ? (
              <InputAdornment
                position="end"
                sx={{
                  marginLeft: (theme) => theme.spacing(1),
                  marginRight: (theme) => theme.spacing(2),
                }}
              >
                <FilterButton
                  onClick={() =>
                    onSort({
                      sortBy,
                      sortDirection:
                        sortDirection === ESortDirection.ASC
                          ? ESortDirection.DESC
                          : ESortDirection.ASC,
                    })
                  }
                  iconName={
                    sortDirection === ESortDirection.ASC ? "north" : "south"
                  }
                />
              </InputAdornment>
            ) : undefined
          }
          options={options}
          sx={(theme) => ({
            [`&.${inputBaseClasses.adornedStart}`]: {
              paddingLeft: theme.spacing(3),
            },
            [`& .${selectClasses.select}`]: {
              fontWeight: sortBy ? 700 : 400,
              lineHeight: 1.5,
              padding: sortBy
                ? "0!important"
                : `${theme.spacing(0, 2.5, 0, 0)} !important`,
            },
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(2),
            ["& .icons.arrow-drop-down"]: {
              display: "none",
            },
          })}
        />
      </Box>
    </Box>
  );
};

export default TableSingleSort;
